import React, { useState } from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { MdOutlineDelete } from "react-icons/md";

const ImgCards = ({
  imgName,
  cardTitle,
  subTitle,
  description,
  editAction,
  availabilityData = [],
  deleteAction,
  toggleAction,
  linkedto,
}) => {
  const [imgError, setImgError] = useState(false);

  const DAY_ORDER = [
    { label: "M", key: "monday" },
    { label: "Tu", key: "tuesday" },
    { label: "W", key: "wednesday" },
    { label: "Th", key: "thursday" },
    { label: "F", key: "friday" },
    { label: "Sa", key: "saturday" },
    { label: "Su", key: "sunday" },
  ];

  const getDayStyle = (dayKey) => {
    const dayData = availabilityData.find(
      (d) => d.key === dayKey && d.isActive,
    );

    if (!dayData) return { background: "#F3F4F6", color: "#303030" };
    if (dayData.isLunch && dayData.isDinner)
      return {
        background: `linear-gradient(135deg, #B472FF 50%, #FF6943 50%)`,
        color: "#fff",
      };
    if (dayData.isLunch) return { background: "#B472FF", color: "#fff" };
    if (dayData.isDinner) return { background: "#FF6943", color: "#fff" };

    return { background: "#F3F4F6", color: "#303030" };
  };
  return (
    <section>
      <div className="max-w-full w-full bg-white rounded-xl border border-[#EEEEEE] p-4 shadow-sm hover:shadow-md transition-shadow duration-200">
        <div onClick={linkedto} className="cursor-pointer">
          {/* Top section */}
          <div className="flex items-start gap-4">
            {imgError ? (
              <div className="rounded-lg h-24 w-24 object-cover shrink-0 bg-gray-200 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
            ) : (
              <img
                src={imgName}
                alt="dish_img"
                onError={() => setImgError(true)}
                className="rounded-lg h-16 w-16 md:h-24 md:w-24 object-cover shrink-0"
              />
            )}

            <div className="flex flex-col gap-1">
              <h1 className="text-md md:text-lg font-semibold text-[#303030]">
                {cardTitle}
              </h1>
              <p className="text-sm font-medium text-[#FF6943]">{subTitle}</p>
            </div>
          </div>

          {/* Description */}
          <p className="text-xs md:text-sm text-[#606060] mt-3 leading-relaxed line-clamp-2 text-ellipsis">
            {description}
          </p>

          {/* Small boxes row */}
          <div className="mt-4 flex flex-wrap gap-2">
            {DAY_ORDER.map((day) => (
              <div
                key={day.key} // ✅ unique key
                className="h-6 w-6 md:h-8 md:w-8 rounded-md flex justify-center items-center text-xs font-medium"
                style={getDayStyle(day.key)}
              >
                {day.label}
              </div>
            ))}
          </div>
        </div>

        {/* Meal type + toggle */}
        <div className="flex justify-between items-center mt-4">
          <div className="flex gap-4">
            <div className="flex items-center gap-2">
              <div className="rounded-full h-3 w-3 bg-[#B472FF]"></div>
              <p className="text-sm text-[#303030]">Lunch</p>
            </div>
            <div className="flex items-center gap-2">
              <div className="rounded-full h-3 w-3 bg-[#FF6943]"></div>
              <p className="text-sm text-[#303030]">Dinner</p>
            </div>
          </div>
          <div>{toggleAction}</div>
        </div>

        {/* Footer actions */}
        <div className="flex justify-between items-center border-t border-[#EEEEEE] mt-4 pt-2">
          <div
            className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition"
            onClick={editAction}
          >
            <HiOutlinePencil className="text-[#004DFF]" size={18} />
            <p className="text-sm text-[#004DFF] font-medium">Edit</p>
          </div>

          <div
            className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition"
            onClick={deleteAction}
          >
            <MdOutlineDelete size={18} className="text-[#EF4B4B]" />
            <p className="text-sm text-[#EF4B4B] font-medium">Delete</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImgCards;
